// @ts-check

import { useCallback } from "react";
import { omit } from "lodash";
import { useOrgConfigForTenant } from "./useOrgConfigForTenant";

// Feature flags returned by the query that must never be written back via the
// tenant config mutation. They are stripped from the payload before saving.
export const OMITTED_TENANT_FEATURE_FLAGS = ["enableAiFeatures"];

/**
 * Hook for managing tenant feature flags config.
 */
export const useOrgFeatureFlagsForTenant = () => {
  const { loading, config, update, updating } = useOrgConfigForTenant();

  const updateFeatureFlags = useCallback(
    /**
     * @param {org_config.tenant.FeatureFlags} newFeatureFlags
     * @returns {Promise<boolean>}
     */
    async (newFeatureFlags) => {
      return update({
        featureFlags: omit(newFeatureFlags, OMITTED_TENANT_FEATURE_FLAGS),
      });
    },
    [update]
  );

  return {
    loading,
    featureFlags: config?.featureFlags,
    update: updateFeatureFlags,
    updating,
  };
};
